import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import type { RequestContactDeleteInterface } from "./contactInfoServiceInterface/deleteContactInfoInterface";
import { ResponseContactDeleteInterface } from "./contactInfoServiceInterface/deleteContactInfoInterface";
import type { RequestContactByIdInterface } from "./contactInfoServiceInterface/getContactByIdInterface";
import { ResponseContactInfoByIDInterface } from "./contactInfoServiceInterface/getContactByIdInterface";
import {
  type RequestContactListInfoInterface,
  ResponseContactListInfoInterface,
} from "./contactInfoServiceInterface/getContactListInfoInterface";
import {
  type RequestContactInfoCreateInterface,
  ResponseContactInfoCreate,
} from "./contactInfoServiceInterface/postContactInfoCreateInterface";
import {
  type RequestContactInfoEditInterface,
  ResponseContactInfoEdit,
} from "./contactInfoServiceInterface/postContactInfoEditInterface";

class ContactInfoServiceApi {
  private baseUrl: string;

  private basePath: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "account/profile";
  }

  // ******************************************************
  // ****************** Method: GET ***********************
  // ******************************************************

  async getContactListInfo(
    params: RequestContactListInfoInterface,
  ): Promise<ResponseContactListInfoInterface> {
    const queryParams = new URLSearchParams(params as any);
    const response = (await apiRequest(
      this.baseUrl,
      `v2/${this.basePath}/listContact?${queryParams}`,
      "GET",
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      false,
    )) as any;

    return new ResponseContactListInfoInterface(response);
  }

  async getContactInfoById(
    params: RequestContactByIdInterface,
  ): Promise<ResponseContactInfoByIDInterface> {
    const queryParams = new URLSearchParams(params as any);
    const response = (await apiRequest(
      this.baseUrl,
      `v2/${this.basePath}/getContact?${queryParams}`,
      "GET",
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      false,
    )) as any;

    return new ResponseContactInfoByIDInterface(response);
  }

  async postContactInfoCreate(params: RequestContactInfoCreateInterface) {
    const response = (await apiRequest(
      this.baseUrl,
      `v2/${this.basePath}/createContact`,
      "POST",
      params,
    )) as any;

    return new ResponseContactInfoCreate(response);
  }

  async postContactInfoEdit(params: RequestContactInfoEditInterface) {
    const response = (await apiRequest(
      this.baseUrl,
      `v2/${this.basePath}/editContact`,
      "POST",
      params,
    )) as any;

    return new ResponseContactInfoEdit(response);
  }

  async deleteContactInfo(params: RequestContactDeleteInterface) {
    const response = (await apiRequest(
      this.baseUrl,
      `v2/${this.basePath}/deleteContact`,
      "POST",
      params,
    )) as any;
    return new ResponseContactDeleteInterface(response);
  }
}

export default ContactInfoServiceApi;
